import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'

export default class SettingsPaymentsForm extends Component {
  static propTypes = {
    hiboutikAccount: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }
  handleSubmitClick = e => {
    this.refs.form.submit()
    if (this.props.onClick) {
      this.props.onClick()
    }
  }
  render() {
    const { hiboutikAccount } = this.props
    const action = `https://${hiboutikAccount}.hiboutik.com/#params_payment_methods`
    return (
      <div>
        <Button color="primary" onClick={this.handleSubmitClick}>
          Modifier les modes de paiement
        </Button>
        <form ref="form" method="post" action={action} target="_blank">
          <input type="hidden" name="show_tab" value="parametres" />
          <input
            type="hidden"
            name="affiche_ma_section_accordion"
            value="params_payment_methods"
          />
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/SettingsPaymentsForm.js